var map = {
	"./ban-cn/1.jpg": "m1fE",
	"./ban-cn/10.jpg": "xqO8",
	"./ban-cn/11.jpg": "xd+M",
	"./ban-cn/12.jpg": "gZQE",
	"./ban-cn/13.jpg": "QtSU",
	"./ban-cn/2.jpg": "G6os",
	"./ban-cn/3.jpg": "11Os",
	"./ban-cn/4.jpg": "n5Et",
	"./ban-cn/5.jpg": "d5iY",
	"./ban-cn/6.jpg": "96j0",
	"./ban-cn/7.jpg": "Ft2d",
	"./ban-cn/8.jpg": "RF3z",
	"./ban-cn/9.jpg": "GZJF",
	"./ban-en/1.jpg": "5W9C",
	"./ban-en/10.jpg": "RnES",
	"./ban-en/11.jpg": "IZNT",
	"./ban-en/12.jpg": "Uah8",
	"./ban-en/13.jpg": "wXkS",
	"./ban-en/2.jpg": "ZWtP",
	"./ban-en/3.jpg": "YE9H",
	"./ban-en/4.jpg": "xSAD",
	"./ban-en/5.jpg": "DNpt",
	"./ban-en/6.jpg": "Sihr",
	"./ban-en/7.jpg": "HbqG",
	"./ban-en/8.jpg": "C1ol",
	"./ban-en/9.jpg": "lpz8",
	"./ban-th/1.jpg": "sRFB",
	"./ban-th/10.jpg": "syul",
	"./ban-th/11.jpg": "8Ixq",
	"./ban-th/12.jpg": "IYd7",
	"./ban-th/13.jpg": "H37F",
	"./ban-th/2.jpg": "Gfd6",
	"./ban-th/3.jpg": "ISJs",
	"./ban-th/4.jpg": "P1OL",
	"./ban-th/5.jpg": "z0ah",
	"./ban-th/6.jpg": "idCk",
	"./ban-th/7.jpg": "5lbB",
	"./ban-th/8.jpg": "rkyB",
	"./ban-th/9.jpg": "WUJB"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YW4s";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4 ^\.\/ban\-.*\.jpg$
// module id = YW4s
// module chunks = 1